<template>
  <v-layout>
    <v-flex xs12 sm10 offset-sm1 >
      <v-card>
        <v-card-title class="primary justify-center">
          <v-container pa-0>
            <v-layout fluid row wrap>
              <v-flex xs12>
                <v-btn
                  v-on:click="redireccion"
                  absolute
                  dark
                  small
                  fab
                  center
                  right
                  class="accent"
                  >
                  <v-icon>add</v-icon>
                </v-btn>
              <h6 class="white--text text-xs-center">Cotizaciones</h6>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm4>
                  <v-dialog
                    persistent
                    v-model="menu"
                    lazy
                    full-width
                  >
                    <v-text-field
                      dark
                      slot="activator"
                      label="Desde"
                      v-model="desde"
                      prepend-icon="event"
                      data-vv-delay="100"
                      readonly
                    ></v-text-field>
                    <v-date-picker v-model="desde" scrollable>
                      <template slot-scope="{ save, cancel }">
                        <v-card-actions>
                          <v-btn flat primary @click.native="cancel()">Cancelar</v-btn>
                          <v-btn flat primary @click.native="save(), filtrarfechainicio()">Aceptar</v-btn>
                        </v-card-actions>
                      </template>
                    </v-date-picker>
                  </v-dialog>
              </v-flex>
              <v-flex xs12 sm4>
                <v-dialog
                    persistent
                    v-model="menu2"
                    lazy
                    full-width
                  >
                    <v-text-field
                      dark
                      slot="activator"
                      label="Hasta"
                      v-model="hasta"
                      prepend-icon="event"
                      readonly
                    ></v-text-field>
                    <v-date-picker v-model="hasta" scrollable >
                      <template slot-scope="{ save, cancel }">
                        <v-card-actions>
                          <v-btn flat primary @click.native="cancel()">Cancelar</v-btn>
                          <v-btn flat primary @click.native="save(), filtrarfechafin()">Aceptar</v-btn>
                        </v-card-actions>
                      </template>
                    </v-date-picker>
                  </v-dialog>
              </v-flex>
              <v-flex xs12 sm4>
                <v-text-field dark
                    v-model="search"
                    name="buscar"
                    label="Buscar"
                    @keyup.enter="buscarcotizacion"
            >

                </v-text-field>
          </v-flex>
            </v-layout>
          </v-container>
        </v-card-title>
          <v-flex style="overflow-x: auto">
             <table class="table">
              <tr>
                <th></th>
                <th></th>
                <th>Cliente</th>
                <th>Fecha</th>
                <th>Total</th>
              </tr>
            <tbody>
              <tr v-for="cotizacion in cotizaciones.results">
                <td>
                  <v-btn icon class="red--text text--darken-2" @click="eliminar(cotizacion)">
                    <v-icon>delete</v-icon>
                  </v-btn></td>
                <td>
                  <v-btn icon class="blue--text text--darken-2" @click="editarcotizacion(cotizacion)">
                    <v-icon>edit</v-icon>
                  </v-btn></td>
                <td class="text-xs-center">{{cotizacion.cliente}}</td>
                <td class="text-xs-center">{{cotizacion.fecha | formatDate}}</td>
                <td class="text-xs-center">Q. {{cotizacion.total_cotizacion}}</td>
              </tr>
            </tbody>
          </table>
          </v-flex>
         <v-card-actions class="justify-center">
          <v-layout row justify-center align-center>
             <v-btn fab dark small primary @click="prev(cotizaciones.previous)" v-if="cotizaciones.previous">
              <v-icon dark>skip_previous</v-icon>
            </v-btn>
             <v-btn fab dark small primary @click="next(cotizaciones.next)" v-if="cotizaciones.next">
            <v-icon>skip_next</v-icon>
          </v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-flex>


  </v-layout>
</template>

<script>
  export default {
    created: function () {
      this.$store.dispatch('getrutas')
      if (this.$store.getters.getdesde || this.$store.getters.gethasta) {
        this.$store.dispatch('actualizarcotizaciones', {
          fecha_minima: this.$store.getters.getdesde,
          fecha_maxima: this.$store.getters.gethasta})
      } else {
        this.$store.dispatch('actualizarcotizaciones')
      }
    },
    data () {
      return {
        menu: false,
        menu2: false,
        fechainicio: '',
        fechafin: '',
        search: '',
        cliente: ''
      }
    },
    methods: {
      redireccion: function () {
        this.$router.push('/cotizacionadd')
      },
      eliminar (cotizacion) {
        let r = confirm(' esta seguro que desea eliminar ' + cotizacion.cliente)
        if (r === true) {
          this.$store.dispatch('eliminarcotizacion', cotizacion)
        }
      },
      editarcotizacion: function (cotizacion) {
        this.$store.commit('resetcotizacion')
        this.$store.commit('actualizarclientecotizacion', cotizacion)
        this.$store.commit('actualizarestadocotizacion', true)
        cotizacion.detalles.map(linea => {
          this.$store.commit('actualizarlineacotizacion', linea)
        })
        this.$router.push('cotizacionadd')
      },
      filtrarfechafin: function () {
        this.$store.dispatch('actualizarcotizaciones', {fecha_maxima: this.$store.getters.gethasta,
          fecha_minima: this.$store.getters.getdesde})
      },
      filtrarfechainicio: function () {
        this.$store.dispatch('actualizarcotizaciones', {fecha_maxima: this.$store.getters.gethasta,
          fecha_minima: this.$store.getters.getdesde})
      },
      buscarcotizacion: function () {
        this.$store.dispatch('actualizarcotizaciones', {search: this.search})
      },
      next: function (dato) {
        this.$store.dispatch('actualizarcotizaciones', dato)
      },
      prev: function (dato) {
        this.$store.dispatch('actualizarcotizaciones', dato)
      }
    },
    computed: {
      cotizaciones: function () {
        return this.$store.getters.listadocotizaciones
      },
      rutas: function () {
        return this.$store.getters.rutas
      },
      ruta: {
        get: function () {
          return this.$store.getters.getruta
        },
        set: function (dato) {
          this.$store.commit('actualizarruta', dato)
        }
      },
      desde: {
        get: function () {
          return this.$store.getters.getdesde
        },
        set: function (dato) {
          this.$store.commit('actualizardesde', dato)
        }
      },
      hasta: {
        get: function () {
          return this.$store.getters.gethasta
        },
        set: function (dato) {
          this.$store.commit('actualizarhasta', dato)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Cotizacion.vue?9b10d152